/**
 * Styled Components - Created by david on 02/04/18.
 */
import styled from 'styled-components'
import { WHITE, BLUE, DARK_TEXT } from '../../theme/colors'
import AntButton from 'antd/lib/button'
import AntdIcon from 'antd/lib/icon'

interface ThemeProps {
  hide?: boolean
  proDesign?: boolean
  darkMode?: boolean
}

export const Container = styled.div`
  align-items: center;
  background-color: ${({ darkMode }: ThemeProps) =>
    darkMode ? 'var(--neutral-darkest)' : WHITE};
  display: ${({ hide }: ThemeProps) => (!hide ? 'flex' : 'none')};
  height: 58px;
  justify-content: space-between;
  line-height: 16px;
  z-index: 9;
  padding: 0 var(--spacing-24);
  width: 100%;
  -webkit-transform: translateZ(10px);
  .userInitials {
    background: var(--neutral-body);
    color: white;
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 25px;
    font: 500 10px var(--font-barlow);
    letter-spacing: 0.144px;
  }
  .ant-badge-count {
    background: #E11D1D;
    transform: unset;
    font-size: 10px;
    box-shadow: unset;
    left: 70%;
    top: -8px;
    height: 16px;
    line-height: 14px;
    font-family: var(--font-barlow);
    width: fit-content;
  }
  & > *:not(:first-child) {
    justify-content: center;
    max-width: 46px;
    width: 100%;
    display: flex;
    @media (max-width: 340px) {
      max-width: 40px;
    }
  }
  @media (max-width: 340px) {
    padding: 0 var(--spacing-12);
  }
`

export const Logo = styled.img`
  height: 100%;
  max-width: 90px;
  margin-right: 12px;
  @media (max-width: 620px) {
    max-width: ${({ proDesign }: ThemeProps) => (proDesign ? '100px' : '90px')};
  }
`

export const Icon = styled.img``

export const Text = styled.div`
  color: ${({ darkMode }: ThemeProps) => (darkMode ? WHITE : DARK_TEXT)};
`

export const Button = styled(AntButton)`
  position: absolute;
  right: 2%;
  color: ${WHITE};
  border-color: ${BLUE};
  background-color: ${BLUE};
  width: 110px;
  height: 50px;

  ${Container}:hover & {
    display: block;
    color: ${WHITE};
    background-color: ${BLUE};
    border-color: ${BLUE};
  }
  ${Container}:active & {
    display: block;
    color: ${WHITE};
    background-color: ${BLUE};
  }
`

export const UserIcon = styled(AntdIcon)`
  font-size: 16px;
  color: white;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/MenuBarMobile/styledComponents.tsx